
import { agentTypeEnum } from '@/store'

const getColorByCategory = (type) => {
  switch (type) {
    case agentTypeEnum.CAgent:
      return 'CAgent'
    case agentTypeEnum.BAgent:
      return 'BAgent'
    case agentTypeEnum.RNAgent:
      return 'RNAgent'
    default:
      return 'dark'
  }
}

export default {
  methods: {
    backgroundByAgentCategory (type) {
      return 'has-background-' + getColorByCategory(type)
    },
    colorByAgentCategory (type) {
      return getColorByCategory(type)
    }
  }
}
